export default __webpack_public_path__ + "static/media/jackpot.3f0c31e9.gif";